import {
    ContextMenuSeparator,
    ContextMenuSub,
    ContextMenuSubContent,
    ContextMenuSubTrigger,
    ContextMenuItem,
} from '@cad-arc';
import { TransportStatusSubmenuView, UnitStateData } from '@mark43/cad-api';
import { formatUnitStateData } from './utils';

export function TransportStatusSubmenu({
    transportStatusSubmenuView,
    onSelect,
}: {
    transportStatusSubmenuView: TransportStatusSubmenuView;
    onSelect: (unitStateData: UnitStateData) => void;
}): React.ReactElement {
    return transportStatusSubmenuView.isVisible ? (
        <ContextMenuSub>
            <ContextMenuSubTrigger>{transportStatusSubmenuView.label}</ContextMenuSubTrigger>
            <ContextMenuSubContent>
                {transportStatusSubmenuView.transportUnitStates.map((unitStateData) => {
                    return (
                        <ContextMenuItem
                            key={unitStateData.id}
                            onSelect={() => onSelect(unitStateData)}
                        >
                            {formatUnitStateData(unitStateData)}
                        </ContextMenuItem>
                    );
                })}
                {transportStatusSubmenuView.showSeparator1 && (
                    <ContextMenuSeparator data-testid="transport-status-submenu-separator-1" />
                )}
                {transportStatusSubmenuView.pursuitUnitStates.map((unitStateData) => {
                    return (
                        <ContextMenuItem
                            key={unitStateData.id}
                            onSelect={() => onSelect(unitStateData)}
                        >
                            {formatUnitStateData(unitStateData)}
                        </ContextMenuItem>
                    );
                })}
                {transportStatusSubmenuView.showSeparator2 && (
                    <ContextMenuSeparator data-testid="transport-status-submenu-separator-2" />
                )}
                {transportStatusSubmenuView.respondingCourtUnitStates.map((unitStateData) => {
                    return (
                        <ContextMenuItem
                            key={unitStateData.id}
                            onSelect={() => onSelect(unitStateData)}
                        >
                            {formatUnitStateData(unitStateData)}
                        </ContextMenuItem>
                    );
                })}
            </ContextMenuSubContent>
        </ContextMenuSub>
    ) : (
        <></>
    );
}
